$(document).ready(function () {
  $("#Dept").focus(function () {
    cleartb();
  });
  $("#Dept").click(function () {
    cleartb();
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scrollup").fadeIn();
    } else {
      $(".scrollup").fadeOut();
    }
  });

  $(".scrollup").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );
    return false;
  });

  $("div#deptdiv").removeClass("hidden");

  $("#formdeptsrch").on("submit", function (e) {
    e.preventDefault();

    var departmentId = document.getElementById("Program").value;

    if (departmentId !== "") {
      document.getElementById("formdeptsrch").submit();
    } else {
      alert("Please enter department code to proceed. ");
    }
  });
});
